import noResult from "~/assets/images/home/no-search-result.png";

type NoResultsProps = {
  message: string;
};

export function NoResults({ message }: NoResultsProps) {
  return (
    <div className="flex h-[300px] flex-col items-center justify-center text-center text-xl font-bold capitalize">
      <div className="size-32 md:size-40">
        <img src={noResult} alt="no result" width={400} height={400} />
      </div>
      <p className="text-center">{message}</p>
    </div>
  );
}
